import { ChangeDetectionStrategy, ChangeDetectorRef, Component, inject, output } from '@angular/core';
import { ReactiveFormsModule, UntypedFormBuilder } from '@angular/forms';

import { PaneComponent } from '@rocksoft/cdk';
import { Wallpaper } from '../../models/set-wallpaper.model';

@Component({
  selector: 'ml-set-wallpaper-ui',
  templateUrl: './set-wallpaper.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [PaneComponent, ReactiveFormsModule],
})
export class SetWallpaperComponent {
  private readonly fb = inject(UntypedFormBuilder);
  private readonly cd = inject(ChangeDetectorRef);

  readonly wallpaper = output<Wallpaper>();

  public readonly wallpaperForm = this.fb.group({
    where: [0],
    image: [],
  });

  onSubmit() {
    this.wallpaper.emit(this.wallpaperForm.value);
  }

  onFileChange(event) {
    if (event.target.files?.length) {
      const file = event.target.files[0];

      this.wallpaperForm.patchValue({
        image: file,
      });

      // need to run CD since file load runs outside of zone
      this.cd.markForCheck();
    }
  }
}
